var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDagdelen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38391 3.35242C6.04336 3.35242 3.32617 6.06964 3.32617 9.41016C3.32617 12.7507 6.04336 15.4679 9.38391 15.4679C9.66281 15.4679 9.88858 15.2421 9.88858 14.9632V3.85712C9.88858 3.57889 9.66281 3.35242 9.38391 3.35242Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70117 18.4102C4.73837 18.4102 0.701172 14.373 0.701172 9.41016C0.701172 4.44736 4.73837 0.410156 9.70117 0.410156C14.664 0.410156 18.7012 4.44736 18.7012 9.41016C18.7012 14.373 14.664 18.4102 9.70117 18.4102ZM9.70117 1.9102C5.56564 1.9102 2.20122 5.27466 2.20122 9.41016C2.20122 13.5457 5.56567 16.9101 9.70117 16.9101C13.8367 16.9101 17.2011 13.5457 17.2011 9.41016C17.2011 5.27466 13.8367 1.9102 9.70117 1.9102Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.701172 0.410156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDagdelen);
export default __webpack_public_path__ + "static/media/Dagdelen.36393e0d80ce57db07227d5fbafbd4b7.svg";
export { ForwardRef as ReactComponent };